import { Environment } from '@dice/app/types/env.type';
import { DEV_ENV_CONFIG } from '@dice/environments/dev/dev.env';
import { NgxLoggerLevel } from 'ngx-logger';

export const DEV_STABLE_ENV_CONFIG: Environment = {
  ...DEV_ENV_CONFIG,
  hostNames: ['dice-dev.dev-scapp-corp.swisscom.com', 'localhost:3000'],
  enableDebugInfo: false,
  isProduction: false,
  variant: 'dice-ui-dev',
  logLevel: NgxLoggerLevel.OFF,
};
